export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '广告',
    dataIndex: 'name',
  },
  {
    title: '备注',
    dataIndex: 'remark',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const pageColumns = [
  {
    title: '排序',
    dataIndex: 'list_order',
    scopedSlots: { customRender: 'list_order' },
  },
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '广告标题',
    dataIndex: 'title',
  },
  {
    title: '描述',
    dataIndex: 'description',
  },
  {
    title: '链接',
    dataIndex: 'url',
  },
  {
    title: '图片',
    dataIndex: 'image',
    scopedSlots: { customRender: 'image' },
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'name',
    lable: '名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'remark',
    lable: '描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];
export const formDataPage = [
  {
    name: 'title',
    lable: '标题',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'url',
    lable: '文章ID',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'description',
    lable: '描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'content',
    lable: '广告内容',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'image',
    lable: '图片',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'list_order',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];